import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { verifyPublicReview } from '../services/api';
import { trackAnalyticsEvent } from '../services/analytics';

const ReviewVerifyPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setError('Missing token.'); return; }
    verifyPublicReview(token)
      .then(() => {
        setState('ok');
        trackAnalyticsEvent('review_verify', { placement: 'email_link' });
      })
      .catch((e: any) => {
        setState('error');
        setError(e?.response?.data?.message ?? e?.response?.data?.error ?? 'Verification link is invalid or expired.');
      });
  }, [token]);

  return (
    <div style={{ maxWidth: 480, margin: '120px auto', padding: 40, textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      {state === 'loading' && <p style={{ color: '#666' }}>Verifying…</p>}
      {state === 'ok' && (
        <>
          <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
          <h2>Review verified</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>
            Thanks! Your review will appear on the listing once it passes moderation.
          </p>
          <Link to="/" style={{ color: '#1a237e', fontWeight: 600 }}>← Back to home</Link>
        </>
      )}
      {state === 'error' && (
        <>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <h2>Couldn't verify</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>{error}</p>
          <Link to="/" style={{ color: '#1a237e', fontWeight: 600 }}>← Back to home</Link>
        </>
      )}
    </div>
  );
};

export default ReviewVerifyPage;
